import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=db7d0660&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/setting.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Setting.vue?vue&type=style&index=1&id=db7d0660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7d0660",
  null
  
)

export default component.exports